import React from "react";
import { Box, Stack, Card, CardContent, Typography } from "@mui/material";
import AppBreadcrumbs from "../../components/AppBreadcrumbs";
import { useNavigate } from "react-router-dom";

const statusButtons = [
  {
    label: "เปิดBatchขาย",
    color: "#1C1E2A",
    textColor: "white",
    url: "/sale/customers",
  },
  {
    label: "Batchรอจ่าย",
    color: "#42A5F5",
    textColor: "white",
    url: "/sale/ticket?status=waiting",
  },
  {
    label: "Batchส่งแล้ว",
    color: "#C5C5C5",
    textColor: "black",
    url: "/sale/ticket?status=sent",
  },
  {
    label: "Batchยืนยันการขายแล้ว",
    color: "#FFBF00",
    textColor: "black",
    url: "/sale/ticket?status=confirm",
  },
  {
    label: "Batchที่รับเงินแล้ว",
    color: "#008000",
    textColor: "white",
    url: "/sale/ticket?status=payed",
  },
  {
    label: "Batchยกเลิก",
    color: "#FF0000",
    textColor: "white",
    url: "/sale/ticket?status=cancel",
  },
];

export default function CameraPanel() {
  const navigate = useNavigate();

  const handleClick = (url) => {
    navigate(url);
  };

  return (
    <>
      <Box p={2}>
        <AppBreadcrumbs />
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          height="100vh"
          boxSizing="border-box"
        >
          <Stack
            direction="row"
            spacing={2}
            sx={{
              width: "100%",
              justifyContent: "center",
              overflowX: "auto",
              padding: 1,
            }}
          >
            {statusButtons.map((item) => (
              <Card
                key={item.label}
                onClick={() => handleClick(item.url)}
                sx={{
                  minWidth: 200,
                  height: 120,
                  backgroundColor: item.color,
                  color: item.textColor,
                  borderRadius: 3,
                  cursor: "pointer",
                  boxShadow: 4,
                  transition: "transform 0.2s",
                  "&:hover": {
                    transform: "scale(1.05)",
                  },
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <CardContent>
                  <Typography
                    variant="h6"
                    align="center"
                    fontWeight="bold"
                    sx={{ whiteSpace: "nowrap" }}
                  >
                    {item.label}
                  </Typography>
                </CardContent>
              </Card>
            ))}
          </Stack>
        </Box>
      </Box>
    </>
  );
}
